import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useLocale } from '../../localization/LocaleContext';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFPreview = ({ fileUrl }) => {
  const { t } = useLocale();
  const [numPages, setNumPages] = React.useState(null);
  const [pageNumber, setPageNumber] = React.useState(1);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  if (!fileUrl) return null;

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Document
        file={fileUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<div style={{ color: '#aaa', fontSize: 18, margin: 32 }}>{t('pdfPreview.loading')}</div>}
      >
        <Page pageNumber={pageNumber} width={600} />
      </Document>
      {numPages && numPages > 1 && (
        <div style={{ marginTop: 12, display: 'flex', gap: 12, alignItems: 'center' }}>
          <button onClick={() => setPageNumber(p => Math.max(1, p - 1))} disabled={pageNumber <= 1}>{t('pdfPreview.prev')}</button>
          <span>{t('pdfPreview.page', { current: pageNumber, total: numPages })}</span>
          <button onClick={() => setPageNumber(p => Math.min(numPages, p + 1))} disabled={pageNumber >= numPages}>{t('pdfPreview.next')}</button>
        </div>
      )}
    </div>
  );
};

export default PDFPreview;
